<h2 mat-dialog-title>Welcome email preview</h2>
<mat-dialog-content>
  <p><strong>To:</strong> {{ data.to }}</p>
  <p><strong>Subject:</strong> {{ data.subject }}</p>
  @if (data.includesTempPassword) {
    <p class="notice">A new temporary password will be generated and the user's current password replaced.</p>
  } @else {
    <div class="notice">
      <message-box type="warn" title="Already logged in">
        This user has already logged in. Their password will not be changed.
      </message-box>
    </div>
  }
  <iframe class="preview" sandbox="" title="Welcome email preview" [srcdoc]="previewHtml"></iframe>
</mat-dialog-content>
<mat-dialog-actions align="end">
  <button mat-stroked-button type="button" (click)="cancel()">Cancel</button>
  <button mat-flat-button color="primary" type="button" (click)="send()">Send</button>
</mat-dialog-actions>
